(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired8f3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired8f3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1Fenh", function(module, exports) {

$parcel$export(module.exports, "ready", function () { return (parcelRequire("6X6nU")).ready; });

var $6X6nU = parcelRequire("6X6nU");

var $e9GSL = parcelRequire("e9GSL");
parcelRequire("iK3Hu");

});
parcelRegister("6X6nU", function(module, exports) {

$parcel$export(module.exports, "ready", function () { return $50fd34982b8395f2$export$28ee1007e174a2a6; });
/**
 * fn will be called when the DOM is ready
 * @param {Function} fn
 */ function $50fd34982b8395f2$export$28ee1007e174a2a6(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', ()=>fn());
}
function $50fd34982b8395f2$export$dbb304eeb4763ed() {
    return new Promise(function(resolve) {
        $50fd34982b8395f2$export$28ee1007e174a2a6(resolve);
    });
}
function $50fd34982b8395f2$export$3f65cefe8380dbea(element, eventType, handler, options) {
    element.addEventListener(eventType, handler, options);
    return ()=>{
        element.removeEventListener(eventType, handler, options);
    };
}

});

parcelRegister("e9GSL", function(module, exports) {
function $a4e32b81cc148292$export$b0b0be3404b52908(el, cb, delay = 2000) {
    let clicksCount = 0;
    let clickTimer;
    function handleTripleClick() {
        clicksCount++;
        if (clicksCount === 1) clickTimer = setTimeout(()=>{
            clicksCount = 0;
        }, delay);
        else if (clicksCount >= 3) {
            clearTimeout(clickTimer);
            clicksCount = 0;
            cb();
        }
    }
    el.addEventListener('click', handleTripleClick);
    return ()=>{
        el.removeEventListener('click', handleTripleClick);
    };
}

});

parcelRegister("iK3Hu", function(module, exports) {
function $da4f64ae79ed53ef$export$125915cfb610b3c2() {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});


parcelRegister("4pzgP", function(module, exports) {

$parcel$export(module.exports, "ActionFormHelper", function () { return $3364db32c196301f$export$dbe53b7003d00c7b; });
function $3364db32c196301f$var$c(l) {
    document.readyState !== "loading" ? l() : document.addEventListener("DOMContentLoaded", ()=>l());
}
function $3364db32c196301f$var$f() {
    return new Promise(function(l) {
        $3364db32c196301f$var$c(l);
    });
}
function $3364db32c196301f$var$n(l, e, t, i) {
    return l.addEventListener(e, t, i), ()=>{
        l.removeEventListener(e, t, i);
    };
}
class $3364db32c196301f$export$14dd5e87e3c1b0c9 {
    get canDisplayError() {
        return this.errLabel && this.errDisplay;
    }
    checkError() {
        if (!this.canDisplayError) throw new Error("Error element not present");
        if (this.errLabel && this.errLabel.innerHTML && this.errDisplay) {
            this.errDisplay.style.display = "";
            const e = this.errLabel.getAttribute("for");
            if (e) {
                const t = document.getElementById(e);
                t && t.value && (t.focus(), this.hasFocus = !0);
            }
        } else this.errDisplay && (this.errDisplay.style.display = "none");
    }
    setInitialFocus(e) {
        if (this.hasFocus) return;
        const t = document.getElementById(e);
        t && /^\s*$/.test(t.value) && (t.focus(), this.hasFocus = !0);
    }
    setError(e, t) {
        if (!this.canDisplayError) throw new Error("Error element not present");
        e.focus(), this.errLabel && (t && (this.errLabel.innerText = t), this.errLabel.setAttribute("for", e.id)), this.errDisplay && (this.errDisplay.style.display = "");
    }
    clearError() {
        if (!this.canDisplayError) throw new Error("Error element not present");
        this.errLabel && (this.errLabel.innerHTML = "", this.errLabel.setAttribute("for", ""), this.errDisplay && (this.errDisplay.style.display = "none"));
    }
    clearValidationErrors() {
        document.querySelectorAll("div.error > span").forEach((t)=>{
            t.innerHTML = "";
        });
    }
    getValidationErrorForElement(e) {
        const t = e instanceof HTMLElement ? e.id : e;
        return document.querySelector(`#${t} ~ div.error > span`);
    }
    clearValidationError(e) {
        const t = this.getValidationErrorForElement(e);
        t && (t.innerText = "");
    }
    setValidationError(e, t, i = !1) {
        if (typeof e == "string") {
            const s = document.querySelector(e);
            s && (s.innerText = t);
        } else {
            const s = e.id;
            i && e.focus();
            const r = this.getValidationErrorForElement(s);
            r && (r.innerText = t);
        }
    }
    focus(e) {
        const t = document.getElementById(e);
        t && t.focus();
    }
    hasClass(e, t) {
        return e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
    }
    addClass(e, t) {
        this.hasClass(e, t) || (e.className += " " + t);
    }
    removeClass(e, t) {
        if (this.hasClass(e, t)) {
            const i = new RegExp("(\\s|^)" + t + "(\\s|$)");
            e.className = e.className.replace(i, " ");
        }
    }
    showHint(e) {
        if (e.value && e.value !== "") {
            const t = e.previousSibling;
            t.style.display = "none";
        } else {
            const t = e.previousSibling;
            t.style.display = "";
        }
    }
    constructor(e = "#errorText", t = "#error"){
        this.errLabel = null, this.errDisplay = null, this.hasFocus = !1, this.errLabel = document.querySelector(e), this.errDisplay = document.querySelector(t);
    }
}
class $3364db32c196301f$export$dbe53b7003d00c7b {
    setInputFields(e) {
        e ? Array.isArray(e) ? (this.requiredFields = e, this.optionalFields = []) : "requiredFields" in e ? (this.requiredFields = e.requiredFields, this.optionalFields = e.optionalFields) : (this.requiredFields = [
            e
        ], this.optionalFields = []) : (this.requiredFields = [], this.optionalFields = []);
    }
    async addEventListeners() {
        if (await $3364db32c196301f$var$f(), this.form) {
            const e = $3364db32c196301f$var$n(this.form, "keypress", (t)=>{
                t.key === "Enter" && (t.preventDefault(), this.submitRequest());
            });
            this.clearHandlers.push(e), this.form.addEventListener("submit", (t)=>{
                this.submitForm && (t.preventDefault(), t.stopPropagation());
            });
        }
        if (this.submitButton) {
            const e = $3364db32c196301f$var$n(this.submitButton, "keypress", (i)=>{
                i.key === " " && (i.preventDefault(), this.submitRequest());
            });
            this.clearHandlers.push(e);
            const t = $3364db32c196301f$var$n(this.submitButton, "click", ()=>{
                this.submitRequest();
            });
            this.clearHandlers.push(t);
        }
        this.requiredFields.forEach((e)=>{
            this.listenInputField(e, !0);
        }), this.optionalFields.forEach((e)=>{
            this.listenInputField(e, !1);
        });
    }
    listenInputField(e, t) {
        if (e) {
            var _this_errorsConfig, _this_errorsConfig1;
            ((_this_errorsConfig = this.errorsConfig) === null || _this_errorsConfig === void 0 ? void 0 : _this_errorsConfig.errorElement) && ((_this_errorsConfig1 = this.errorsConfig) === null || _this_errorsConfig1 === void 0 ? void 0 : _this_errorsConfig1.on) === "input" && $3364db32c196301f$var$n(e, "input", ()=>{
                var _this_errorsConfig;
                ((_this_errorsConfig = this.errorsConfig) === null || _this_errorsConfig === void 0 ? void 0 : _this_errorsConfig.errorElement) && (this.errorsConfig.errorElement.innerHTML = "");
            }, {
                once: !0
            });
            const i = $3364db32c196301f$var$n(e, "input", ()=>{
                window.hasModelErrors = !1, t ? this.checkSubmitButtonState(e) : this.checkSubmitButtonState();
            });
            this.clearHandlers.push(i);
        }
    }
    dispose() {
        this.clearHandlers.forEach((e)=>e());
    }
    [Symbol.dispose]() {
        this.dispose();
    }
    validate(e, t) {
        if (typeof this.validateForm == "function") return this.validateForm(e, t);
        var _this_validateForm_failEarly;
        const i = (_this_validateForm_failEarly = this.validateForm.failEarly) !== null && _this_validateForm_failEarly !== void 0 ? _this_validateForm_failEarly : !0;
        let s = !0, r = !0;
        for (const o of this.validateForm.validators){
            if (!o.input) {
                console.error("Validator item is missing input element");
                continue;
            }
            if (o.validator(o.input.value)) {
                var _o_onError;
                if (t ? ((_o_onError = o.onError) === null || _o_onError === void 0 ? void 0 : _o_onError.call(o), this.inputUtil.setValidationError(o.input, o.error, r), r = !1) : this.inputUtil.clearValidationErrors(), s && (s = !1), i) return !1;
            } else s && (s = !0);
        }
        return s;
    }
    submitRequest() {
        var _this_errorsConfig, _this_errorsConfig1;
        ((_this_errorsConfig = this.errorsConfig) === null || _this_errorsConfig === void 0 ? void 0 : _this_errorsConfig.errorElement) && ((_this_errorsConfig1 = this.errorsConfig) === null || _this_errorsConfig1 === void 0 ? void 0 : _this_errorsConfig1.on) === "submit" && (this.errorsConfig.errorElement.innerHTML = ""), this.validate(this.inputUtil, this.errors) && (this.loader.style.display = "inline-block", this.submitForm === null ? this.isSubmitButtonEnabled && this.submitButton.click() : this.submitForm()), typeof window.history.replaceState == "function" && window.history.replaceState(null, "", window.location.href);
    }
    checkSubmitButtonState(e, ...t) {
        let i = !1;
        typeof e == "boolean" && e ? i = this.validate(this.inputUtil, this.errors) : i = this.validate(this.inputUtil);
        const s = t.every((r)=>!!(r.value && r.value.length > 0));
        i && s ? (this.inputUtil.clearValidationErrors(), this.enableButtons(this.submitButton)) : this.disableButtons(this.submitButton);
    }
    clearValidationError(e) {
        this.inputUtil.clearValidationError(e);
    }
    setValidationError(e, t) {
        this.inputUtil.setValidationError(e, t);
    }
    enableButtons(...e) {
        e.forEach((t)=>{
            t.classList.remove("disabled"), t.removeAttribute("disabled"), t === this.submitButton && (t.classList.remove("selected"), this.isSubmitButtonEnabled = !0);
        });
    }
    disableButtons(...e) {
        e.forEach((t)=>{
            t.classList.add("disabled"), t.setAttribute("disabled", "disabled"), t === this.submitButton && (this.isFormLocked && this.isSubmitButtonEnabled && t.classList.add("selected"), this.isSubmitButtonEnabled = !1);
        });
    }
    lock() {
        this.isFormLocked = !0, this.disableButtons(...document.querySelectorAll("button")), this.requiredFields.concat(this.optionalFields).forEach((e)=>e === null || e === void 0 ? void 0 : e.setAttribute("disabled", "disabled"));
    }
    unlock() {
        this.enableButtons(...document.querySelectorAll("button")), this.requiredFields.concat(this.optionalFields).forEach((e)=>e === null || e === void 0 ? void 0 : e.removeAttribute("disabled")), this.loader.style.display = "none", this.isFormLocked = !1;
    }
    constructor(e, t, i, s, r, o, a = null, u = "#errorText", h = "#error", d = null){
        this.form = e, this.submitButton = t, this.loader = i, this.errors = s, this.validateForm = o, this.errorsConfig = a, this.errTextElementSelector = u, this.errDisplayElementSelector = h, this.submitForm = d, this.requiredFields = [], this.optionalFields = [], this.clearHandlers = [], this.isFormLocked = !1, this.isSubmitButtonEnabled = !1, this.inputUtil = new $3364db32c196301f$export$14dd5e87e3c1b0c9(this.errTextElementSelector, this.errDisplayElementSelector), this.setInputFields(r), this.requiredFields.length < 1 && (this.isSubmitButtonEnabled = !0), this.addEventListeners();
    }
}

});

parcelRequire("1Fenh");
var $6X6nU = parcelRequire("6X6nU");

var $4pzgP = parcelRequire("4pzgP");
(0, $6X6nU.ready)(function() {
    const emailRegex = /\S+@\S+\.\S+/;
    const email = document.querySelector("#emailInput");
    const password = document.querySelector("#password");
    const maxPasswordLength = 128;
    const _actionFormHelper = new (0, $4pzgP.ActionFormHelper)(document.querySelector("#actionForm"), document.querySelector("#submitButton"), document.querySelector("#loader"), window.errors, [
        email,
        password
    ], {
        failEarly: true,
        validators: [
            {
                input: email,
                error: window.errors.EmailFormatError,
                validator: (value)=>!value || !emailRegex.test(value)
            },
            {
                input: password,
                error: window.errors.PasswordEmpty,
                validator: (value)=>!(value === null || value === void 0 ? void 0 : value.trim()),
                onError: ()=>{
                    password.value = "";
                }
            },
            {
                input: password,
                error: window.errors.PasswordTooLong,
                validator: (value)=>value.length > maxPasswordLength
            }
        ]
    });
});

})();
//# sourceMappingURL=legacy-login-form-validation.js.map
